<template>
	<div class="mb-3">
		<div class="form-check">
		<input
			class="form-check-input"
			:class="inputClass"
			type="radio"
			:name='name'
			:id="inputId"
			:value="option.value"
			:checked = "option.value === value"
			@change="$emit('input', option.value)"
		/>
		<label :for="name" class="form-check-label">{{ option.label }}</label>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},
		name: {
			type: String,
			required: true
		},
		option: {
			type: Object,
			required: true
		},
		value: {
			type: String,
			required: true
		},
		inputClass: {
			type: String,
			required: false
		},
		inputId: {
			type: String,
			required: true
		}
	}
}
</script>